import emojiSheetUrl from 'emoji-datasource-twitter/img/twitter/sheets/32.png';
import {
  EMOJI_ADDED_IN_VERSIONS,
  EMOJI_ARTWORK_POSITIONS,
  EMOJI_SHEET_COLUMNS,
} from './emojiArtwork.generated.js';

export const EMOJI_ARTWORK_CELL_SIZE = 34;
export const EMOJI_ARTWORK_SOURCE_SIZE = 32;
export const EMOJI_ARTWORK_SHEET_SIZE = 2108;
export const EMOJI_ARTWORK_SHEET_URL = emojiSheetUrl;
export const EMOJI_ARTWORK_FALLBACK = '❓';
export const EMOJI_NATIVE_BASELINE_VERSION = 5;
export const EMOJI_NATIVE_APPLE_VERSION = 14;
export const EMOJI_ARTWORK_MAX_SEQUENCE_LENGTH = Object.keys(EMOJI_ARTWORK_POSITIONS).reduce(
  (maximum, key) => Math.max(maximum, key.split('-').length),
  1,
);

const PRESENTATION_SELECTOR_PATTERN = /-fe0f/g;
const APPLE_PLATFORM_PATTERN = /(?:Mac|iPhone|iPad|iPod)/i;

export const emojiArtworkKey = (emoji) =>
  Array.from(String(emoji || ''))
    .map((character) => character.codePointAt(0).toString(16))
    .join('-');

export const resolveEmojiArtworkPosition = (emoji) => {
  const key = emojiArtworkKey(emoji);
  const packedPosition =
    EMOJI_ARTWORK_POSITIONS[key] ??
    EMOJI_ARTWORK_POSITIONS[key.replace(PRESENTATION_SELECTOR_PATTERN, '')];
  if (!Number.isInteger(packedPosition)) return null;
  return {
    x: packedPosition % EMOJI_SHEET_COLUMNS,
    y: Math.floor(packedPosition / EMOJI_SHEET_COLUMNS),
  };
};

export const hasEmojiArtwork = (emoji) => resolveEmojiArtworkPosition(emoji) != null;

export const resolveEmojiAddedInVersion = (emoji) => {
  const key = emojiArtworkKey(emoji);
  return (
    EMOJI_ADDED_IN_VERSIONS[key] ??
    EMOJI_ADDED_IN_VERSIONS[key.replace(PRESENTATION_SELECTOR_PATTERN, '')] ??
    null
  );
};

export const resolveEmojiPlatform = () => {
  if (typeof navigator === 'undefined') return 'universal';
  const platform = `${navigator.platform || ''} ${navigator.userAgent || ''}`;
  return APPLE_PLATFORM_PATTERN.test(platform) ? 'apple' : 'universal';
};

export const canUseNativeEmoji = (emoji, platform = resolveEmojiPlatform()) => {
  const addedIn = resolveEmojiAddedInVersion(emoji);
  if (!Number.isFinite(addedIn)) return false;
  const maximumVersion =
    platform === 'apple' ? EMOJI_NATIVE_APPLE_VERSION : EMOJI_NATIVE_BASELINE_VERSION;
  return addedIn <= maximumVersion;
};

export const resolveEmojiRendering = (
  emoji,
  rendering = 'hybrid',
  platform = resolveEmojiPlatform(),
) => {
  if (rendering === 'native' || rendering === 'artwork') return rendering;
  return canUseNativeEmoji(emoji, platform) ? 'native' : 'artwork';
};

export const resolveRenderableEmojiArtwork = (emoji) => {
  const position = resolveEmojiArtworkPosition(emoji);
  if (position) {
    return {
      emoji,
      position,
      isFallback: false,
    };
  }

  return {
    emoji: EMOJI_ARTWORK_FALLBACK,
    position: resolveEmojiArtworkPosition(EMOJI_ARTWORK_FALLBACK),
    isFallback: true,
  };
};
